module.exports = __webpack_public_path__ + "assets/img/ComponentManagement.bdf1e82b.png";